import { API_ENDPOINT } from "../../endpoint";

export const retrieveRoleByIdService = async (APIKey: any, id: string,) => {
    try {
        const response = await fetch(`${API_ENDPOINT}/utility/role/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `APIKey ${APIKey}`,
                'Content-Type': 'application/json'
            },
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res.data;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
